export const documentAttributes = ["TDO"];
export const countryAttributes = ["PEX", "NAC", "PAI", "EPI", "ECY", "PRE"];
export const roadTypeAttributes = ["VIA", "EVI"];
export const otherAttributes = ["GEN", "LAN", "EPA"];
export const addressUseCodeAttributes = ["PAI", "PRO", "POB", "VIA", "CPO", "EPI", "EVI", "EPR", "EPO", "ECP"];
export const multipleAttributes = ["EMA", "TDO", "PEX", "NDO", "FCA", "PRE", "MOV"];
export const groupAttributes = { userData: "DPE", userAddress: "DPO", enterpriseData: "DEA", enterpriseAddress: "FAD" };
export const addressUserCodeAttributes = ["PAI", "PRO", "POB", "VIA", "DIR", "AD1", "CPO"];
export const addressEnterpriseCodeAttributes = ["EPI", "EVI", "EPR", "EPO", "ECP"];
